import React, { useState } from 'react';
import { auth } from '../../../firebase'; // Ensure your config exports auth
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import '../login_page/login_page.css';
import { setPersistence, browserSessionPersistence } from "firebase/auth";

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await setPersistence(auth, browserSessionPersistence);
      await signInWithEmailAndPassword(auth, email, password);
      alert("Login successful!");
      navigate('/member-dashboard-parm'); // Redirect to your member area
    } catch (error) {
      console.error(error);
      alert("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert("Please enter your email address first to reset your password.");
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset link sent to your email!");
    } catch (error) {
      alert("Error: " + error.message);
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Welcome Back</h2>
        <p>Enter detail below to log into your PArM Membership Account</p>

        <div className="input-group-login">
          <label>Email Address</label>
          <input 
            type="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="example@mail.com"
            required 
          />
        </div>

        <div className="input-group-login">
          <label>Password</label>
          <div className="password-wrapper-login">
            <input 
              type={showPassword ? "text" : "password"} 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required 
              style={{ width: '100%', paddingRight: '40px' }}
            />
            <button 
              type="button" 
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        <button type="submit" className="login-btn" disabled={loading}>
          {loading ? "Verifying..." : "Login"}
        </button>

        <div className="login-footer">
          <button 
            type="button" 
            className="forgot-password-btn" 
            onClick={() => navigate('/forgot-password-parm')}
          >
            Forgot Password?
          </button>
          <p>Don't have an account? <span onClick={() => navigate('/membership-registration-parm')}>Sign Up</span></p>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;